var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.exam && _vm.userExam && !_vm.userExam.finishedAt
    ? _c(
        "div",
        {
          staticClass: "exam-result",
          attrs: { "justify-content-center": "", wrap: "" },
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c("v-alert", { attrs: { value: true, type: "warning" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("exam_result.warning_finish_exam", {
                        format: _vm.LETTER_FORMAT.UPTITLECASE,
                      })
                    ) +
                    "\n    "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm.exam && _vm.exam.hideResult
    ? _c(
        "div",
        { staticClass: "align-center mt-2" },
        [
          _c("h2", [_vm._v("テストの結果は公開していません。")]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { color: "primary", dark: "" },
              on: { click: _vm.gotoTop },
            },
            [_vm._v("\n    テスト一覧戻す\n  ")]
          ),
        ],
        1
      )
    : _vm.exam && _vm.userExam && _vm.userExam.isWaitingScoreCheck
    ? _c(
        "div",
        { staticClass: "align-center mt-2" },
        [
          _c("h2", [_vm._v("テストを提出しました。ありがとうございます。")]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { color: "primary", dark: "" },
              on: { click: _vm.gotoTop },
            },
            [_vm._v("\n    テスト一覧戻す\n  ")]
          ),
        ],
        1
      )
    : _vm.exam
    ? _c(
        "div",
        [
          _vm.user && _vm.user.isGuest
            ? [
                _c(
                  "div",
                  { staticClass: "guest-update" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-center",
                      },
                      [
                        _c("v-col", { attrs: { cols: "12", lg: "8" } }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column justify-content-center align-items-center",
                            },
                            [
                              _c("div", { staticClass: "fs-1 text-center" }, [
                                _vm._v("テスト結果閲覧はメール登録が必要です"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-6 fs-6 text-center" },
                                [
                                  _vm._v(
                                    "\n              お名前、メールアドレス、パスワードを入力して、ユーザー登録ボタンをクリックしてください。"
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "※入力したメールアドレスに確認メールが届きます\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("UserUpdateFormView", {
                      staticClass: "guest-update-form",
                      attrs: { showPreview: false, mode: "guest_update" },
                    }),
                  ],
                  1
                ),
              ]
            : [
                !_vm.mobile
                  ? _c(
                      "ExamResultWeb",
                      {
                        attrs: {
                          exam: _vm.exam,
                          "user-exam": _vm.userExam,
                          examQScoreHistory: _vm.examQScoreHistory,
                          groupQuestions: _vm.groupQuestions,
                          banners: _vm.banners,
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "result-head" },
                          [
                            _vm.getIsPreviusExamResultRouter()
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "ps-0 ms-1 white-text",
                                    attrs: { text: "" },
                                    on: { click: _vm.backToExamResult },
                                  },
                                  [
                                    _c("v-icon", { attrs: { left: "" } }, [
                                      _vm._v("navigate_before"),
                                    ]),
                                    _vm._v(" "),
                                    _c("v-toolbar-title", [
                                      _vm._v("\n            戻る\n          "),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "template",
                          { slot: "result-body d-none" },
                          [
                            _c("CommentContainer", {
                              staticClass: "p-4",
                              attrs: {
                                commentable: _vm.commentable,
                                user: _vm.user,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  : _c(
                      "ExamResultMobile",
                      {
                        attrs: {
                          exam: _vm.exam,
                          "user-exam": _vm.userExam,
                          examQScoreHistory: _vm.examQScoreHistory,
                          groupQuestions: _vm.groupQuestions,
                          banners: _vm.banners,
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "result-head" },
                          [
                            _vm.getIsPreviusExamResultRouter()
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "ps-0 ms-1 white-text",
                                    attrs: { text: "" },
                                    on: { click: _vm.backToExamResult },
                                  },
                                  [
                                    _c("v-icon", { attrs: { left: "" } }, [
                                      _vm._v("navigate_before"),
                                    ]),
                                    _vm._v(" "),
                                    _c("v-toolbar-title", [
                                      _vm._v("\n            戻る\n          "),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "template",
                          { slot: "comment-body d-none" },
                          [
                            _c("CommentContainer", {
                              staticClass: "p-4",
                              attrs: {
                                commentable: _vm.commentable,
                                user: _vm.user,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                _vm._v(" "),
                _c("v-divider"),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }